"use client";

import React from "react";
import { Check, Minus } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const plans = [{
  id: "trad",
  name: "Trad. Büro",
  isPopular: false,
  link: "/BookViewingPage"
}, {
  id: "flex",
  name: "Flex Desk",
  isPopular: false,
  link: "/CoworkingSpacePage"
}, {
  id: "fix",
  name: "Fix Desk",
  isPopular: false,
  link: "/CoworkingSpacePage"
}, {
  id: "team",
  name: "Team Office",
  isPopular: true,
  link: "/CoworkingSpacePage"
}];
const features = [{
  name: "Vertragslaufzeit",
  values: ["5-10 Jahre", "Monatlich", "Monatlich", "Flexibel"]
}, {
  name: "Monatliche Fixkosten",
  values: ["Hoch", "Gering", "Mittel", "Planbar"]
}, {
  name: "Einrichtung & Design",
  values: ["Eigenregie", "Inklusive", "Inklusive", "Inklusive"]
}, {
  name: "Inklusive Nebenkosten",
  values: [false, true, true, true]
}, {
  name: "Community & Events",
  values: [false, true, true, true]
}, {
  name: "Kaffee & Wasser Flat",
  values: [false, true, true, true]
}, {
  name: "24/7 Sicherer Zugang",
  values: [true, false, true, true]
}, {
  name: "Reinigungsservice",
  values: [false, true, true, true]
}, {
  name: "Skalierbarkeit",
  values: ["Eingeschränkt", "Sofort", "Sofort", "Schnell"]
}];
export default function PackageComparisonOverview() {
  return;
}